import {
    PropertyDescriptionTypes,
    NumberPropertyDescription,
    StringPropertyDescription,
    ComponentTypeDescription,
    SelectPropertyDescription,
    PropertyTypeDescription
} from 'models';

export const isNumberProperty = (property: PropertyDescriptionTypes): property is NumberPropertyDescription => {
    return property.type === PropertyTypeDescription.Number;
};

export const isStringProperty = (property: PropertyDescriptionTypes): property is StringPropertyDescription => {
    return property.type === PropertyTypeDescription.String;
};

export const isNumberableSelectProperty = (property: PropertyDescriptionTypes): property is SelectPropertyDescription => {
    return property.componentType === ComponentTypeDescription.Select && property.type === PropertyTypeDescription.Number;
};

export const isDateProperty = (property: PropertyDescriptionTypes): property is StringPropertyDescription => {
    return property.componentType === ComponentTypeDescription.Date;
};

export const isBooleanProperty = (property: PropertyDescriptionTypes): boolean => {
    return property.componentType === ComponentTypeDescription.CheckBox && property.type === PropertyTypeDescription.Boolean;
};